var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"neutral"},[(_vm.role == 'patient')?_c('PatientExams'):(_vm.role == 'partner_place')?_c('PartnerExams'):_c('DoctorExams')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }